module.exports = __webpack_public_path__ + "img/artillery-wagon-base-13.beea9708.png";